import { BASE_PATH } from '../constants';

export const CHECK_STATUS_REQUEST = 'CHECK_STATUS_REQUEST';
export const CHECK_STATUS_SUCCESS = 'CHECK_STATUS_SUCCESS';
export const CHECK_STATUS_FAILURE = 'CHECK_STATUS_FAILURE';
export const SEND_STATS_REQUEST = 'SEND_STATS_REQUEST';
export const SEND_STATS_SUCCESS = 'SEND_STATS_SUCCESS';
export const SEND_STATS_FAILURE = 'SEND_STATS_FAILURE';
export const SEND_STATS_OPTIMISTIC = 'SEND_STATS_OPTIMISTIC';
export const SEND_STATS_ROLLBACK = 'SEND_STATS_ROLLBACK';

export const checkStatusRequest = () => ({
  type: CHECK_STATUS_REQUEST,
});

export const checkStatusSuccess = (data) => ({
  type: CHECK_STATUS_SUCCESS,
  payload: data,
});

export const checkStatusFailure = (error) => ({
  type: CHECK_STATUS_FAILURE,
  payload: error,
});

export const sendStatsRequest = () => ({
  type: SEND_STATS_REQUEST,
});

export const sendStatsSuccess = (data) => ({
  type: SEND_STATS_SUCCESS,
  payload: data,
});

export const sendStatsFailure = (error) => ({
  type: SEND_STATS_FAILURE,
  payload: error,
});

export const sendStatsOptimistic = ({ msisdn, accepted }) => ({
  type: SEND_STATS_OPTIMISTIC,
  payload: { msisdn, accepted },
});

export const sendStatsRollback = () => ({
  type: SEND_STATS_ROLLBACK,
});

export const checkStats = (msisdn) => async (dispatch) => {
  dispatch(checkStatusRequest());

  try {
    const response = await fetch(
      `${BASE_PATH}/privacy/consent?msisdn=${msisdn}`,
      {
        method: 'GET',
        headers: {
          'content-type': 'application/json',
        },
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    dispatch(checkStatusSuccess(data));
    return data;
  } catch (error) {
    dispatch(checkStatusFailure(error.message));
    throw error;
  }
};

export const sendStats = ({ msisdn, accepted, timestamp }) => async (dispatch) => {
  dispatch(sendStatsOptimistic({ msisdn, accepted }));
  dispatch(sendStatsRequest());

  try {
    const response = await fetch(`${BASE_PATH}/privacy/consent`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        msisdn,
        status: accepted ? 1 : 0,
        timestamp,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    dispatch(sendStatsSuccess(data));
    return data;
  } catch (error) {
    dispatch(sendStatsRollback());
    dispatch(sendStatsFailure(error.message));
    throw error;
  }
};
